// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-ccwge{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-htxtc{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-hmnbj{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bwenn{grid-column:span 3}.assets-scss-gridstyleGrid-col4-boivw{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bvaww{grid-column:span 9}.assets-scss-gridstyleGrid-col12-bujdk{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bmdhe{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-ccwge",
	"grid": "assets-scss-gridstyleGrid-grid-htxtc",
	"col6": "assets-scss-gridstyleGrid-col6-hmnbj",
	"col3": "assets-scss-gridstyleGrid-col3-bwenn",
	"col4": "assets-scss-gridstyleGrid-col4-boivw",
	"col9": "assets-scss-gridstyleGrid-col9-bvaww",
	"col12": "assets-scss-gridstyleGrid-col12-bujdk",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bmdhe"
};
module.exports = ___CSS_LOADER_EXPORT___;
